import { useSelector } from "react-redux";
import { ExtractFnReturnType, QueryConfig } from "../../../lib/react-query";
import { getImprovementPlans } from "../api/improvementPlanAPI";
import { RootState } from "../../../redux/store";
import { useQuery } from "@tanstack/react-query";
import { PaginationFilterDto } from "../../../types/Pagination";

type QueryFnType = typeof getImprovementPlans;

type UseSearchImprovementPlansOptions = {
    config?: QueryConfig<QueryFnType>;
};

export const useImprovementPlans = ({ config }: UseSearchImprovementPlansOptions = {}) => {
    const selectedFilters = useSelector((state: RootState) => state.filters.improvementPlans.selectedFilters);
    const pagination = useSelector((state: RootState) => state.historical.improvementPlans);
    const filterByCurrentUser = useSelector((state: RootState) => state.filters.improvementPlans.filterByCurrentUser);

    const paginationFilters: PaginationFilterDto =
    {
        pageNumber: pagination.currentPage,
        pageSize: pagination.itemsPerPage,
        search: pagination.searchText,
        filterByCurrentUser: filterByCurrentUser,
        filters: selectedFilters,
        selectedOrganizationalStructureIds: []
    };


    return useQuery<ExtractFnReturnType<QueryFnType>>({
        ...config,
        refetchOnMount: true,
        refetchOnWindowFocus: false,
        retry: false,
        queryKey: ['getimprovementPlans', selectedFilters, pagination, filterByCurrentUser],
        queryFn: () => getImprovementPlans(paginationFilters),
    });
};